import React, { useEffect, useState } from "react";
import GenericList from "../shared/components/GenericList";
import { GridColDef } from "@mui/x-data-grid";
import { betsileoUrl } from "../../configs/URL";


export interface KoboData {
    id: number;
    nom_et_prenom: string;
    H1_Tlt_Presence: string;
    H2_Tlt_Presence: string;
    H3_Tlt_Presence: string;
    H4_Tlt_Presence: string;
    H1_Tlt_Fako: string;
    H2_Tlt_Fako: string;
    H3_Tlt_Fako: string;
    H4_Tlt_Fako: string;
}


export const KoboDataTable: React.FC = () => {
    const [data, setData] = useState<KoboData[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await fetch(betsileoUrl);
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const json = await res.json();

                // Mapper uniquement les champs qui nous intéressent
                const mapped: KoboData[] = json.results.map((r: any) => ({
                    id: r._id,
                    nom_et_prenom: r.nom_et_prenom ?? "",
                    H1_Tlt_Presence: r.H1_Tlt_Presence ?? "",
                    H2_Tlt_Presence: r.H2_Tlt_Presence ?? "",
                    H3_Tlt_Presence: r.H3_Tlt_Presence ?? "",
                    H4_Tlt_Presence: r.H4_Tlt_Presence ?? "",
                    H1_Tlt_Fako: r.H1_Tlt_Fako ?? "",
                    H2_Tlt_Fako: r.H2_Tlt_Fako ?? "",
                    H3_Tlt_Fako: r.H3_Tlt_Fako ?? "",
                    H4_Tlt_Fako: r.H4_Tlt_Fako ?? "",
                }));

                setData(mapped);
            } catch (err: any) {
                setError(err.message || "Erreur de chargement");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) return <div>Chargement…</div>;
    if (error) return <div style={{ color: "red" }}>Erreur: {error}</div>;

    // Define columns for GenericList


    const KoboDataField: GridColDef[] = [
        { field: 'nom_et_prenom', headerName: 'Nom et Prénom', flex: 2 },
        { field: 'H1_Tlt_Presence', headerName: 'Présence H1', flex: 1 },
        { field: 'H2_Tlt_Presence', headerName: 'Présence H2', flex: 1 },
        { field: 'H3_Tlt_Presence', headerName: 'Présence H3', flex: 1 },
        { field: 'H4_Tlt_Presence', headerName: 'Présence H4', flex: 1 },
        { field: 'H1_Tlt_Fako', headerName: 'Fako H1', flex: 1 },
        { field: 'H2_Tlt_Fako', headerName: 'Fako H2', flex: 1 },
        { field: 'H3_Tlt_Fako', headerName: 'Fako H3', flex: 1 },
        { field: 'H4_Tlt_Fako', headerName: 'Fako H4', flex: 1 },
    ];


    return (
        <div style={{ padding: "16px" }}>
            <GenericList columns={KoboDataField} rows={data} />   
        </div>
    );
};

const thStyle: React.CSSProperties = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "center",
    fontWeight: "bold",
};

const tdStyle: React.CSSProperties = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "center",
};

export default KoboDataTable;
